import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-buy-now',
  templateUrl: './buy-now.component.html',
  styleUrls: ['./buy-now.component.scss']
})
export class BuyNowComponent implements OnInit {
 @Input() label: string = '';
  @Input() ribbonBg: string = ''
  @Input() index!: number;
  @Input() pass: any;
  @Input() disabled = false;
  @Output() buyClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }
  handleClick() {
    this.buyClick.emit({ pass: this.pass, index: this.index });
  }
}
